import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';

const sourcesWithInternalSplitting = ['tiktok'];

export function ContainsMarketplaceWithInternalSplitting(items: SmartSendItemApiModel[]): boolean {
  // Marketplaces where items are imported and dispatched at the package level
  // allowing splitting will mean the sync will remove
  // the split items once the whole package is dispatched
  return items.some(
    (item) =>
      item.MarketplaceOrderLines &&
      item.MarketplaceOrderLines.some((ol) => sourcesWithInternalSplitting.includes(ol.Source.Id))
  );
}
